import { useMemo } from 'react';

// Reads a Split.io treatment the way the legacy app does
// (window.splitHelper.getTreatment(name) === 'on'). Memoised per name;
// Split treatments do not change during a page view.
const useFeatureFlag = (name) => useMemo(() => {
  const helper = typeof window !== 'undefined' ? window.splitHelper : undefined;
  return !!helper && helper.getTreatment(name) === 'on';
}, [name]);

export default useFeatureFlag;
